// extracted by mini-css-extract-plugin
export default {"container":"About_container__9W3wA","text":"About_text__oOKTW","links":"About_links__K4I6k"};